import React from 'react';
import { cn } from '@/lib/utils';
import cherryBlossomBranch from '@/assets/bohostyleco-cherry-blossom-branch.png';

interface BohoTextLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  textColor?: string; // Override text color for different backgrounds
}

const BohoTextLogo: React.FC<BohoTextLogoProps> = ({
  className,
  size = 'md',
  textColor = 'text-primary'
}) => {
  const sizeConfig = {
    sm: {
      containerHeight: 'h-12',
      containerWidth: 'w-48',
      branchHeight: 'h-12',
      textSize: 'text-lg',
      textSpacing: 'tracking-wide'
    },
    md: {
      containerHeight: 'h-[72px]',
      containerWidth: 'w-56',
      branchHeight: 'h-[72px]',
      textSize: 'text-2xl',
      textSpacing: 'tracking-wider'
    },
    lg: {
      containerHeight: 'h-20',
      containerWidth: 'w-64',
      branchHeight: 'h-20',
      textSize: 'text-3xl',
      textSpacing: 'tracking-widest'
    }
  };

  const config = sizeConfig[size];

  return (
    <div 
      className={cn(
        'relative flex items-center',
        config.containerHeight,
        config.containerWidth,
        className
      )}
    >
      {/* Cherry Blossom Branch Background - Full Height */}
      <div className="absolute inset-0 flex items-center justify-start">
        <img
          src={cherryBlossomBranch}
          alt=""
          className={cn(
            'w-full object-contain object-left opacity-70',
            config.branchHeight
          )}
          style={{ 
            filter: 'brightness(1.2) contrast(1.1) saturate(1.2) hue-rotate(10deg)'
          }}
          aria-hidden="true"
        />
      </div>
      
      {/* Text Overlay - Right Aligned */}
      <div className="relative z-10 flex flex-col items-end justify-center w-full">
        <h1 
          className={cn(
            'font-boho leading-none text-right',
            config.textSize,
            config.textSpacing,
            textColor
          )}
          style={{
            textShadow: '0 1px 3px hsl(var(--background) / 0.6), 0 0 12px hsl(var(--background) / 0.3)',
            filter: 'drop-shadow(0 1px 1px hsl(var(--primary) / 0.2))'
          }}
        >
           Boho Style Co.
        </h1>
      </div>
      
      {/* Subtle glow effect */}
      <div 
        className="absolute inset-0 bg-gradient-radial from-primary/3 via-transparent to-transparent opacity-30 pointer-events-none"
        aria-hidden="true"
      />
    </div>
  );
};

export default BohoTextLogo;